import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';
import { CampaignExecution } from '../models/campaign-search.model';

export const loadColumns = createAction(
  '[Campaign Executions]: Load Columns',
  props<{ columns: { [label: string]: string } }>(),
);

export const campaignExecutionsCountInit = createAction('[Campaign Executions]: Count Init');

export const campaignExecutionsCountSuccess = createAction(
  '[Campaign Executions]: Count Success',
  props<{ count: number }>(),
);

export const campaignExecutionsCountFailed = createAction(
  '[Campaign Executions]: Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const campaignExecutionsInit = createAction('[Campaign Executions]: Executions Init');

export const campaignExecutionsSuccess = createAction(
  '[Campaign Executions]: Executions Success',
  props<{ data: CampaignExecution[] }>(),
);

export const campaignExecutionsFailed = createAction(
  '[Campaign Executions]: Executions Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const pagingChanged = createAction(
  '[Campaign Executions]: Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const openCostModal = createAction(
  '[Campaign Executions]: Open Cost Modal',
  props<{ selectedRow: any }>(),
);

export const costChanged = createAction(
  '[Campaign Executions]: Cost Changed',
  props<{ updatedCostValue: number }>(),
);

export const updateCostInit = createAction('[Campaign Executions]: Update Cost Init');

export const updateCostSuccess = createAction('[Campaign Executions]: Update Cost Success');

export const updateCostFailed = createAction(
  '[Campaign Executions]: Update Cost Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const closeCostModal = createAction('[Campaign Executions]: Close Cost Modal');

export const openRecipientsModal = createAction(
  '[Campaign Executions]: Open Recipients Modal',
  props<{ selectedRow: any }>(),
);

export const closeRecipientsModal = createAction('[Campaign Executions]: Close Recipients Modal');

export const controlGroupChanged = createAction('[Campaign Executions]: Control Group Changed');

export const excludedChanged = createAction('[Campaign Executions]: Excluded Changed');

export const downloadRecipientsInit = createAction(
  '[Campaign Executions]: Download Recipients Init',
);

export const downloadRecipientsSuccess = createAction(
  '[Campaign Executions]: Download Recipients Success',
  props<{ response: any }>(),
);

export const downloadRecipientsFailed = createAction(
  '[Campaign Executions]: Download Recipients Failed',
  props<{ error: HttpErrorResponse }>(),
);
